module.exports = __webpack_public_path__ + "static/img/icon-SYD.87d8d7e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-SYD.svg
// module id = VP6a
// module chunks = 0